import { __values } from "tslib";
import { chainFn } from './utils/chain-fn';
import { isFn } from './utils/is-fn';
export function mergeProps() {
    var e_1, _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = {};
    try {
        for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
            var props = args_1_1.value;
            for (var key in result) {
                if (/^on[A-Z]/.test(key) && isFn(props[key]) && isFn(result[key])) {
                    result[key] = chainFn(result[key], props[key]);
                }
                else if (key === 'aria-labelledby' && props[key] && result[key]) {
                    var currentPropValues = result[key].split(' ');
                    if (!currentPropValues.includes(props[key])) {
                        currentPropValues.push(props[key]);
                    }
                    result[key] = currentPropValues.join(' ');
                }
                else {
                    result[key] = props[key] !== undefined ? props[key] : result[key];
                }
            }
            // Add props from b that are not in a
            for (var key in props) {
                if (result[key] === undefined) {
                    result[key] = props[key];
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}
